import React, { Component } from 'react';
import styled from 'styled-components';
import {
  TooltipRenderProps,
} from 'react-joyride';
const Tooltip = ({
  continuous,
  index,
  isLastStep,
  step,
  backProps,
  primaryProps,
  skipProps,
  tooltipProps,
}: TooltipRenderProps) => {
  console.log(index);
  return (
    <TooltipBody {...tooltipProps}>
      {step.title && <TooltipTitle>{step.title}</TooltipTitle>}
      {step.content && <TooltipContent>{step.content}</TooltipContent>}
      <TooltipFooter>
        {!isLastStep && (
          <Button {...skipProps} spacer={true}>
            <div id="skip" />
          </Button>
        )}
        {index > 0 && (
          <Button {...backProps}>
            <div id="back" />
          </Button>
        )}
        <Button {...primaryProps}>
          <div id={continuous ? 'next' : 'close'} />
        </Button>
      </TooltipFooter>
    </TooltipBody>
  );
};
export default Tooltip
const Wrapper = styled.div`
  background-color: #ccc;
  box-sizing: border-box;
  min-height: 100vh;
  padding: 20px 0 70px;
  position: relative;
`;

const Heading = styled.h1`
  margin: 0;
  text-align: center;
`;

const SubHeading = styled.h3`
  color: #f04;
  text-align: center;

  a {
    color: inherit;
    text-decoration: underline;
  }
`;

const Row = styled.div`
  align-items: center;
  display: flex;
  white-space: nowrap;
`;

const Button = styled.button`
  background-color: #f04;
  color: #fff;
  margin-right: ${(props: { spacer?: boolean }) => (props.spacer ? 'auto' : 0)};
  padding: 1.1rem;
`;

const Input = styled.input`
  -webkit-appearance: none;
  border: 0.1rem solid #f04;
  padding: 0.6rem;
  width: 75%;
`;

const TooltipBody = styled.div`
  background-color: #fff;
  min-width: 290px;
  max-width: 420px;
  position: relative;
`;

const TooltipContent = styled.div`
  color: #000;
  padding: 20px;
`;

const TooltipTitle = styled.h2`
  color: #f04;
  padding: 20px;
  margin: 0;
`;

const TooltipFooter = styled.div`
  background-color: #ffccda;
  display: flex;
  justify-content: flex-end;
  margin-top: 1rem;
  padding: 5px;

  * + * {
    margin-left: 0.5rem;
  }

  ${Button} {
    padding: 0.8rem;
  }
`;



// WEBPACK FOOTER //
// ./src/Tour/Tooltip.js